
import api from './api'

export default {

    getAll() {

        return api.get('/listes', {})
            .then( json => json.data )
            
    },

    getPurchasable() {

        return api.get('/listes/purchasable', {})
            .then( json => json.data )
            
    }
}
